import Vue from 'vue'
import VueRouter, {
  RouteConfig
} from 'vue-router'
import Login from '../views/Login.vue'
import store from '../store/index'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/resetPassword/:token',
    name: 'ResetPassword',
    component: () => import( '../views/ResetPassword.vue'),
  },
  {
    path: '/dashboard',
    //name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(  '../views/Dashboard.vue'),
    meta: {
      requiresAuthorization: true,
    },
    children: [{
      path: '',
      name: 'DashboardMain',
      component: () => import(  '../views/DashboardMain.vue'),
      meta: {
        requiresAuthorization: true,
        type: ['1', '2', '3', '4', '5', '6']
      }
    },
    {
      name: 'Profile',
      path: 'profile',
      component: () => import(  '../views/Profile.vue'),
      meta: {
        requiresAuthorization: true,
        type: ['1', '2', '3', '4', '5', '6']
      }
    },
    {
      name: 'Translations',
      path: 'config-translations',
      component: () => import(  '../views/wadmin/ConfigTranslations.vue'),
      meta: {
        requiresAuthorization: true,
        type: ['1']
      }
    },
    {
      name: 'Labels',
      path: 'labels',
      component: () => import(  '../views/wadmin/Labels.vue'),
      meta: {
        requiresAuthorization: true,
        type: ['1']
      }
    },
    {
      // name: 'ProductsMain',
      path: 'products',
      component: { render(h) { return h('router-view') }},
      children:[
        {
          name: 'Products',
          path: '',
          component: () => import(  '../views/Products.vue'),
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          }
        },
        {
          name: 'Product',
          path: ':productId',
          component: () => import(  '../views/Product.vue'),
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          }
        },
      ]
    },
    {
      name: 'Protocol',
      path: 'protocol',
      component: () => import(  '../views/Protocol.vue'),
      meta: {
        requiresAuthorization: true,
        type: ['1', '2', '3', '4', '5', '6']
      }
    },
      {
        name: 'SalesPartnershipUsers',
        path: 'sale-partnership-users',
        component: () => import( '../views/spadmin/SalesPartnershipUsers.vue'),
        meta: {
          requiresAuthorization: true,
          type: ['1', '2', '3', '4', '5', '6']
        }
      },
    {
      // name: 'Orders',
      path: 'orders',
      component: { render(h) { return h('router-view') }},
      children:[
        {
          name: 'OrdersMain',
          path: '',
          component: () => import(  '../views/OrdersMain.vue'),
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          }
        },
        {
          name: 'OrderDetails',
          path: ':orderId',
          component: () => import(  '../views/OrderDetails.vue'),
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          }
        },
      ]
    },
        // Settings Routes
      {
        path: 'settings',
        component: { render(h) { return h('router-view') }},
        children:[
          {
            name: 'PricingConditions',
            path: 'pricing',
            component: () => import(  '../views/settings/pricingConditions/PricingMain.vue'),
            meta: {
              requiresAuthorization: true,
              type: ['1', '2', '3', '4', '5', '6']
            }
          },
          {
            name: 'MaterialMapping',
            path: 'mapping',
            component: () => import(  '../views/settings/MaterialMapping.vue'),
            meta: {
              requiresAuthorization: true,
              type: ['1', '2', '3', '4', '5', '6']
            }
          },
        ]
      },

    // {
    //   name: 'Statistics',
    //   path: 'statistics',
    //   component: () => import( '../views/StatisticsBusinessAnalytics.vue'),
    //   meta: {
    //     requiresAuthorization: true,
    //     type: ['3']
    //   }
    // },
    // {
    //   // name: 'WertheimSalesMain',
    //   path: 'wertheim-sales',
    //   component: { render(h) { return h('router-view') }},
    //   children:[
    //     {
    //       name: 'WertheimSales',
    //       path: '',
    //       component: () => import(  '../views/wadmin/WertheimSales.vue'),
    //       meta: {
    //         requiresAuthorization: true,
    //         type: ['1', '3']
    //       }
    //     },
    //     {
    //       name: 'WAUser',
    //       path: ':userId',
    //       meta: {
    //         requiresAuthorization: true,
    //         type: ['1', '2', '3', '4', '5', '6']
    //       },
    //       component: () => import( '../views/wadmin/WAUser.vue'),
    //     },
    //   ]
    // },

    {
      // name: 'SalePartnerships',
      path: 'sale-partnerships',
      component: { render(h) { return h('router-view') }},
      children:[
        {
          name: 'SalePartnershipsTable',
          path: '/',
          component: () => import(  '../views/wadmin/SalePartnerships.vue'),
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          },
        },
        {
          name: 'SalesPartnerCompany',
          path: ':companyId',
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          },
          component: () => import( '../views/wadmin/SalesPartnerCompany.vue'),
        },
        {
          name: 'SalesPartnerCompanyDetails',
          path: ':companyId/:userId',
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          },
          component: () => import( '../views/wadmin/WAUser.vue'),
        },
        {
          name: 'SpaUserOrderDetails',
          path: ':companyId/:userId/:orderId',
          component: () => import(  '../views/OrderDetails.vue'),
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          }
        },
        {
          name: 'SpaUserProductDetails',
          path: ':companyId/:userId/:productId',
          component: () => import(  '../views/Product.vue'),
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          }
        },
        {
          name: 'AffiliateCompanyDetails',
          path: ':companyId/:affiliateCompanyId',
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          },
          component: () => import( '../views/spadmin/AffiliateCompany.vue'),
        },
        {
          name: 'AffiliateUserDetails',
          path: ':companyId/:affiliateCompanyId/:affiliateUserId',
          meta: {
            requiresAuthorization: true,
            type: ['1', '2', '3', '4', '5', '6']
          },
          component: () => import( '../views/wadmin/WAUser.vue'),
        },
      ]
    },
    // {
    //   name: 'AffiliateCompany',
    //   path: 'affiliate-partner-company/:companyId',
    //   meta: {
    //     requiresAuthorization: true,
    //     type: ['1', '2', '3', '4', '5', '6']
    //   },
    //   component: () => import( '../views/spadmin/AffiliateCompany.vue'),
    // },
    {
      name: 'SPAUser',
      path: 'spa-user/:userId',
      meta: {
        requiresAuthorization: true,
        type: ['1', '2', '3', '4', '5', '6']
      },
      component: () => import( '../views/spadmin/SPAUser.vue'),
    },
    {
      name: 'AffiliateUser',
      path: 'afiliate-user/:userId',
      meta: {
        requiresAuthorization: true,
        type: ['1', '2', '3', '4', '5', '6']
      },
      component: () => import('../views/spadmin/AffiliateUser.vue'),
    },
    {
      name: 'Users',
      path: 'users',
      meta: {
        requiresAuthorization: true,
        type: ['1', '2', '3', '4', '5', '6']
      },
      component: () => import( '../views/spadmin/Users.vue'),
    },
    {
      name: 'AffiliatePartnershipSales',
      path: 'affiliate-partnership-sales',
      meta: {
        requiresAuthorization: true,
        type: ['3']
      },
      component: () => import( '../views/spadmin/AffiliatePartnershipSales.vue'),
    },
    {
      name: 'TableFilters',
      path: 'table-filters',
      component: () => import(  '../views/TableFilters.vue'),
      meta: {
        requiresAuthorization: true,
        type: ['1', '2', '3', '4', '5', '6']
      },
    },
    ]
  },
  {
    path: '/product-configurator/',
    name: 'configurator',
    redirect: '/product-configurator/model-selection',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      requiresAuthorization: true,
      type: ['1', '2', '3', '4', '5', '6']
    },
    props: true,
    component: () => import('../views/productConfigurator/Configurator.vue'),
    children: [
      {
        path: 'model-selection',
        name: 'ModelSelection',
        meta: {
          requiresAuthorization: true,
          type: ['1', '2', '3', '4', '5', '6']
        },
        component: () => import('../views/productConfigurator/ModelSelection.vue'),
      },
      {
        path: 'functions',
        name: 'Functions',
        meta: {
          requiresAuthorization: true,
          type: ['1', '2', '3', '4', '5', '6']
        },
        component: () => import('../views/productConfigurator/Functions.vue'),
      },
      {
        path: 'frame',
        name: 'Frame',
        meta: {
          requiresAuthorization: true,
          type: ['1', '2', '3', '4', '5', '6']
        },
        component: () => import('../views/productConfigurator/Frame.vue'),
      },
      {
        path: 'measure',
        name: 'Measure',
        meta: {
          requiresAuthorization: true,
          type: ['1', '2', '3', '4', '5', '6']
        },
        component: () => import('../views/productConfigurator/Measure.vue'),
      },
      {
        path: 'door-leaf-surface',
        name: 'DoorLeafSurface',
        meta: {
          requiresAuthorization: true,
          type: ['1', '2', '3', '4', '5', '6']
        },
        component: () => import('../views/productConfigurator/DoorLeafSurface.vue'),
      },
      {
        path: 'exterior-accessory',
        name: 'ExteriorAccessory',
        meta: {
          requiresAuthorization: true,
          type: ['1', '2', '3', '4', '5', '6']
        },
        component: () => import('../views/productConfigurator/ExteriorAccessory.vue'),
      },
      {
        path: 'mounting-material',
        name: 'MountingMaterial',
        meta: {
          requiresAuthorization: true,
          type: ['1', '2', '3', '4', '5', '6']
        },
        component: () => import('../views/productConfigurator/MountingMaterial.vue'),
      },
      {
        path: 'blindstock-multiplex',
        name: 'BlindstockMultiplex',
        meta: {
          requiresAuthorization: true,
          type: ['1', '2', '3', '4', '5', '6']
        },
        component: () => import('../views/productConfigurator/BlindstockMultiplex.vue'),
      },
      {
        path: 'further-info',
        name: 'FurtherInfo',
        meta: {
          requiresAuthorization: true,
          type: ['1', '2', '3', '4', '5', '6']
        },
        component: () => import('../views/productConfigurator/FurtherInfo.vue'),
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuthorization) {
    if (!store.getters.isAuthenticated) {
      next({
        name: 'Login'
      })
    } else {
      if (to.meta.type) {
        if (to.meta.type.includes(store.getters.getUserType)) {
          next()
        } else {
          next({
            name: 'Dashboard'
          })
        }
      } else {
        next()
      }
    }
  } else {
    if (to.name == 'Login' && store.getters.isAuthenticated){
      next({
        name: 'DashboardMain'
      })
    }
    else{
      next()
    }
  }
})

router.afterEach((to, from) => {
  store.dispatch("storeRoute", from.path);
});

export default router